import { TranslationDict } from "../types";

export const nlSettings: TranslationDict = {
  instellingen: "Instellingen",

  gebruikPaketten: "Gebruik pakketten",
  infoPakettenAan1: "Aangevinkt gebruiken we pakketten indien van toepassing.",
  infoPakettenAan2: "Uitgevinkt zullen losse modules gebruikt worden.",

  gebruikEnkelSa: "Gebruik enkel REL04SA modules (geen REL08)",
  infoSaAan1: "Aangevinkt gebruiken we enkel de 'Stand Alone' relais module.",
  infoSaAan2: "Uitgevinkt zal er ook een REL08 module gebruikt worden.",

  upgradeController: "Upgrade controller bij x adressen",
  infoUpgradeController1: "Een ctd kan maximaal 388 gebruiken.",
  infoUpgradeController2: "Stel hier in bij welk aantal adressen er een extra controller moet bijkomen.",
  
  standaardUitvoering: "Standaard uitvoering",
  infoStandaardUitvoering: "Stel hier in welke afwerking jouw toetsen moeten hebben.",

  taal: "Taal",
  infoTaal: "Stel hier jouw voorkeurstaal in.",
};